import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaBolt, FaFire } from 'react-icons/fa';

const ComboDisplay = ({ combo, multiplier }) => {
  const getComboColor = () => {
    if (combo >= 20) return 'from-red-500 via-orange-500 to-yellow-500';
    if (combo >= 10) return 'from-purple-500 via-pink-500 to-red-500';
    if (combo >= 5) return 'from-blue-500 via-purple-500 to-pink-500';
    return 'from-green-500 via-blue-500 to-purple-500';
  };

  const getComboIcon = () => {
    if (combo >= 10) return <FaFire className="text-orange-400 animate-pulse" />;
    return <FaBolt className="text-yellow-300" />;
  };

  const getComboText = () => {
    if (combo >= 20) return '🔥 超級連擊!';
    if (combo >= 10) return '💥 驚人連擊!';
    if (combo >= 5) return '⚡ 很棒!';
    return '✨ 連擊中';
  };

  // 只在連擊大於1時顯示
  if (combo <= 1) return null;

  // 手機版優化 - 縮小尺寸
  const isMobile = window.innerWidth < 768;

  return (
    <div className="fixed bottom-24 sm:bottom-32 left-0 w-full flex justify-center pointer-events-none z-50">
      <motion.div
        initial={{ scale: 0, opacity: 0, y: 50 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0, opacity: 0, y: -50 }}
      >
        <motion.div
          animate={{
            scale: [1, 1.05, 1],
            rotate: combo >= 10 ? [0, -3, 3, 0] : 0
          }}
          transition={{
            duration: 0.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }}
          className={`
            bg-gradient-to-r ${getComboColor()} text-white 
            px-3 py-1.5 sm:px-6 sm:py-3 
            rounded-full shadow-2xl 
            flex items-center gap-1.5 sm:gap-2 
            border-2 sm:border-3 border-white
            ${combo >= 10 ? 'animate-pulse' : ''}
          `}
        >
          <div className="text-base sm:text-2xl">
            {getComboIcon()}
          </div>

          <div className="flex flex-col">
            <div className="text-[8px] sm:text-xs font-bold uppercase tracking-wide opacity-90 leading-tight">
              {isMobile 
                ? (combo >= 20 ? '超級!' : combo >= 10 ? '驚人!' : combo >= 5 ? '很棒!' : '連擊')
                : getComboText()
              }
            </div>
            <div className="text-base sm:text-2xl font-black leading-tight">
              {combo}x 連擊
            </div>
          </div>

          {multiplier > 1 && (
            <div className="ml-1 sm:ml-2 bg-white/30 px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-full">
              <span className="text-[10px] sm:text-xs font-bold">×{multiplier.toFixed(1)}</span>
            </div>
          )}
        </motion.div>

        {/* Particle Effects - 手機版縮小 */}
        {combo >= 10 && (
          <div className="absolute inset-0 pointer-events-none">
            {[...Array(8)].map((_, i) => (
              <motion.div
                key={i}
                className="absolute w-1 h-1 sm:w-1.5 sm:h-1.5 bg-yellow-400 rounded-full"
                initial={{ x: 0, y: 0, opacity: 1 }}
                animate={{
                  x: Math.cos(i * 45 * Math.PI / 180) * (isMobile ? 30 : 50),
                  y: Math.sin(i * 45 * Math.PI / 180) * (isMobile ? 30 : 50),
                  opacity: 0
                }}
                transition={{
                  duration: 1,
                  repeat: Infinity,
                  ease: 'easeOut'
                }}
                style={{
                  left: '50%',
                  top: '50%'
                }}
              />
            ))}
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default ComboDisplay;